import React, { Component } from 'react';

import EventButtons from './event-buttons';

class EventItem extends Component {
	render() {
		const event = this.props.event;
		return (
			<article className="two-col-content-panel">
				<div className="col-sm-8">
					<div role="tabpanel" className="tab-pane fade in active">
						<header>
							<div className="entry-meta">
								{ event.start_date } | { event.city }
							</div>
							<h3 className="entry-title">
								<a href={ event.link } dangerouslySetInnerHTML={ { __html: event.title.rendered } } />
							</h3>
						</header>
						<div className="entry-content" dangerouslySetInnerHTML={ { __html: event.subtitle } } />
					</div>
				</div>
				<div className="col-sm-4 attached-documents">
					<EventButtons link={ event.link } />
				</div>
			</article>
		);
	}
}

export default EventItem;